<template>
  <footer class="bg-white dark:bg-gray-900 shadow text-center py-2 dark:text-gray-300">
    <span class="text-gray-500 text-sm dark:text-gray-300">© 2024 Mi Empresa</span>
  </footer>
</template> 